import { render, staticRenderFns } from "./PaymentHistoryPage.vue?vue&type=template&id=67326add&scoped=true&"
import script from "./PaymentHistoryPage.vue?vue&type=script&lang=ts&"
export * from "./PaymentHistoryPage.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentHistoryPage.vue?vue&type=style&index=0&id=67326add&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67326add",
  null
  
)

export default component.exports